(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-intelligent-search-v1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-new-search]';
    const SESSION_KEY = 'new-search-home-greeting-seen';

    const phrases = {
          "time": {
                "morning": [
                      "Good morning",
                      "Morning looks good on you",
                      "A fresh day, a fresh shelf",
                      "Good morning — let’s find something lovely",
                      "Morning — the shelves are open",
                      "Good morning — what does the house need today?",
                      "A new day is a good excuse to look around",
                      "Good morning — start with something beautiful and useful",
                      "Morning light makes everything feel possible",
                      "Good morning — there is plenty of day for a good find",
                      "Fresh coffee, fresh start, fresh shelves",
                      "Good morning — let curiosity lead for a minute"
                ],
                "afternoon": [
                      "Good afternoon",
                      "A little afternoon wandering sounds right",
                      "Good afternoon — consider this a productive detour",
                      "Still plenty of day for a good find",
                      "Good afternoon — the shelves have ideas",
                      "The afternoon could use something interesting",
                      "Good afternoon — a little browsing feels justified",
                      "Afternoon light, good taste, no rush",
                      "Good afternoon — find one thing that makes home easier",
                      "A small afternoon upgrade sounds reasonable",
                      "Good afternoon — what are we hunting for?",
                      "The day is not over and neither are the possibilities"
                ],
                "evening": [
                      "Good evening",
                      "The day is winding down. The browsing can begin",
                      "Good evening — something cozy seems appropriate",
                      "Evening is a fine time to wander the shelves",
                      "Good evening — the house is settling in",
                      "The errands are over. The wandering can begin",
                      "Good evening — find something worth coming home to",
                      "Evening light makes cozy decisions easier",
                      "Good evening — maybe the house wants something too",
                      "The day got quieter. The shelves did not",
                      "Good evening — this feels like a good hour for a find",
                      "A slower evening deserves a little browsing"
                ],
                "late": [
                      "Still up?",
                      "The shelves are still awake too",
                      "A little late-night wandering never hurt",
                      "The sensible purchases can happen tomorrow",
                      "Late night, good taste, questionable restraint",
                      "Still browsing? We respect the commitment",
                      "The house is asleep. Your ideas are not",
                      "One more look before bed?",
                      "Late-night finds have a way of feeling important",
                      "Still up — maybe you are supposed to find it tonight",
                      "The quiet hours are excellent for noticing what home needs",
                      "Midnight is still technically shopping time"
                ]
          },
          "timeTails": {
                "morning": [
                      "plenty of day left to find something lovely.",
                      "the day has barely started, and the shelves are already tempting.",
                      "a small delight seems like a reasonable way to begin.",
                      "fresh coffee, fresh light, fresh possibilities.",
                      "start with the useful thing that also happens to be beautiful.",
                      "the house looks different in morning light — maybe it needs something new.",
                      "today has excellent little-upgrade potential.",
                      "one thoughtful find can set the tone for the whole day.",
                      "the best kind of productive detour starts right here.",
                      "there is still time to make one corner of home work better.",
                      "something simple and lovely sounds like a strong start.",
                      "the day is young enough for a completely unnecessary favorite.",
                      "maybe today begins with the thing you have been meaning to replace.",
                      "the shelves are ready whenever the coffee is.",
                      "a good morning can absolutely include a good find."
                ],
                "afternoon": [
                      "there’s still plenty of day for a good find.",
                      "consider this your productive little detour.",
                      "the afternoon could use something interesting.",
                      "a little browsing feels perfectly justified.",
                      "one useful find still counts as getting something done.",
                      "the day is far enough along to deserve a tiny reward.",
                      "maybe the missing piece is sitting on a shelf somewhere.",
                      "the house might have one more request before dinner.",
                      "there is time left for one very good idea.",
                      "something practical can still be the fun part of the day.",
                      "this is exactly the hour for a small, satisfying upgrade.",
                      "the afternoon slump has met its match: wandering the shelves.",
                      "one good find can make the rest of the day feel accomplished.",
                      "there is no rule against making the practical choice prettier.",
                      "a little curiosity is a perfectly acceptable afternoon plan."
                ],
                "evening": [
                      "the errands are over. The wandering can begin.",
                      "something cozy feels especially appropriate now.",
                      "the house is quiet enough to notice what it wants next.",
                      "this feels like a good hour to find something lovely.",
                      "home is doing most of the talking now.",
                      "the quieter part of the day deserves easier decisions.",
                      "one small comfort can change the whole evening.",
                      "the day is winding down, but your list does not have to.",
                      "maybe tonight is for finding the thing you keep thinking about.",
                      "the house has settled in enough to make its opinions known.",
                      "a useful little luxury sounds especially convincing after dark.",
                      "this is prime time for imagining a better shelf, drawer, or table.",
                      "the best evening plans sometimes involve staying home and improving it.",
                      "the light is softer and suddenly everything needs a little texture.",
                      "tonight has very strong “just one more look” energy."
                ],
                "late": [
                      "the shelves are still awake too.",
                      "a little late-night wandering never hurt.",
                      "the sensible decisions can wait until morning.",
                      "maybe the best finds happen after everyone else logs off.",
                      "this is when the oddly specific searches begin.",
                      "one last look has historically become several.",
                      "the quiet makes it easier to notice what you actually like.",
                      "late-night taste is still taste.",
                      "your future self can judge the cart in daylight.",
                      "the house is quiet enough for one more idea.",
                      "some decisions improve when nobody is rushing you.",
                      "the practical voice in your head has gone to bed.",
                      "a strangely perfect find would be very on-brand for this hour.",
                      "the night shift at the general store is apparently you.",
                      "if you find the perfect thing now, technically tomorrow-you benefits."
                ]
          },
          "seasonal": {
                "deepWinter": [
                      "winter is asking the house to soften a little.",
                      "the cold days are still here, so cozy gets another turn.",
                      "the season for staying in is still making its case.",
                      "warm corners and useful little comforts are having a moment.",
                      "winter still has a few cozy ideas left.",
                      "the cold outside is making the indoors work harder.",
                      "blanket weather is still firmly in charge.",
                      "the house deserves a little warmth while winter hangs around.",
                      "cold mornings make practical comforts feel especially luxurious.",
                      "winter is not done yet, but neither is cozy season.",
                      "the best room in the house is whichever one feels warmest.",
                      "cold-weather nesting is still completely justified.",
                      "the light is slowly returning, but warm corners are still winning.",
                      "winter has one request: make home worth staying in."
                ],
                "springAhead": [
                      "spring is starting to make plans.",
                      "longer days are quietly finding their way back.",
                      "the house might be ready for its first little refresh.",
                      "winter is loosening its grip, one bright corner at a time.",
                      "spring is not here yet, but the light has started gossiping.",
                      "the season is beginning to turn toward open windows.",
                      "a fresher chapter is getting closer.",
                      "the first hints of spring are already rearranging the mood.",
                      "winter is still here, but spring has entered the group chat.",
                      "brighter mornings are starting to make plans for the house.",
                      "the heavy season is getting ready to lighten up.",
                      "spring cleaning energy is arriving before spring itself.",
                      "the house is starting to ask for a little less winter.",
                      "longer light is making everything look ready for a refresh.",
                      "the thaw is coming — the shelves can start getting ready.",
                      "spring is waiting just around the corner with opinions."
                ],
                "spring": [
                      "spring has the windows asking to be opened.",
                      "a lighter season deserves a lighter little reset.",
                      "the house is waking up along with everything outside.",
                      "fresh-air season has officially entered the chat.",
                      "spring is a very convincing argument for starting fresh.",
                      "open-window weather changes the whole mood of a room.",
                      "the season of clearing out and bringing in has arrived.",
                      "spring makes even practical things feel a little prettier.",
                      "the light is back, and suddenly every corner is visible again.",
                      "fresh season, fresh shelves, same good taste.",
                      "spring is asking for fewer heavy things and more breathing room.",
                      "a little green, a little light, a little reset.",
                      "the house is officially out of hibernation.",
                      "spring has a way of making “maybe we should replace that” feel urgent."
                ],
                "summerAhead": [
                      "summer is warming up in the wings.",
                      "long days and easy evenings are almost here.",
                      "the easygoing season is starting to show itself.",
                      "summer plans are beginning to look suspiciously real.",
                      "the house is getting ready for open doors and longer evenings.",
                      "warmer days are close enough to start planning for.",
                      "summer is almost here, and the table knows it.",
                      "the season of casual dinners and cold drinks is approaching.",
                      "sunny-day habits are beginning to make their way back.",
                      "the porch is about to become a room again.",
                      "long evenings are nearly here — the house might want to prepare.",
                      "summer is getting close enough to taste.",
                      "the easygoing season is almost ready to move in.",
                      "warm-weather hosting is quietly entering the calendar."
                ],
                "summer": [
                      "summer is still making a very good case for itself.",
                      "long days call for easy, useful things.",
                      "the windows are open and the house feels lighter.",
                      "summer has the shelves feeling a little more relaxed.",
                      "this is the season for cold drinks and low-effort beauty.",
                      "summer makes the kitchen work overtime and the table look better.",
                      "the easy season deserves easy favorites.",
                      "sun-warmed days make simple things feel like enough.",
                      "the house is in its barefoot era.",
                      "long evenings make everything feel a little less urgent.",
                      "summer is a good excuse to keep things light.",
                      "warm weather has very strong “use the good glasses” energy.",
                      "the season is casual, but the details can still be good.",
                      "summer says the useful things should also be easy on the eyes."
                ],
                "lateSummer": [
                      "summer’s nearly packed its bags.",
                      "autumn is starting to knock.",
                      "the cozy season is creeping closer.",
                      "summer had a good run — autumn is waiting in the wings.",
                      "the light is changing already.",
                      "cooler days are coming. The house might want a head start.",
                      "consider this your first little nudge toward autumn.",
                      "almost sweater weather. Almost.",
                      "summer is still here, but autumn has started sending hints.",
                      "the calendar says summer; the shadows are starting to disagree.",
                      "late summer is quietly turning the volume down.",
                      "the evenings are getting shorter, and the cozy ideas are getting louder.",
                      "autumn has not arrived, but it has definitely been browsing.",
                      "summer is winding down one golden evening at a time.",
                      "the first cool morning is closer than it looks.",
                      "we are officially entering “maybe bring a sweater” territory.",
                      "the season is shifting, even if the temperature has not gotten the memo.",
                      "summer is lingering, but fall is already rearranging the shelves.",
                      "the last stretch of summer is asking for one more easy evening.",
                      "golden-hour season is getting a little more golden.",
                      "the house is about to remember how much it likes cozy things.",
                      "autumn is close enough to start making room for.",
                      "summer is almost over — the softer season is next.",
                      "one foot in summer, one eye on sweater weather."
                ],
                "autumn": [
                      "autumn has officially moved in.",
                      "the house is entering its cozy era.",
                      "cool mornings are making everything feel a little more intentional.",
                      "this is the season for warm corners and good things within reach.",
                      "fall has arrived with very strong nesting energy.",
                      "the air is cooler and suddenly every room wants texture.",
                      "autumn is the house’s favorite excuse to get comfortable.",
                      "the season of layers has reached the shelves too.",
                      "cool evenings make a convincing case for staying in.",
                      "fall is here — bring on the warm wood, soft light, and useful things.",
                      "the house has officially switched to cozy mode.",
                      "autumn makes everyday rituals feel a little more important.",
                      "this is prime season for mugs, baskets, blankets, and better lighting.",
                      "the days are shorter; the rooms can get warmer.",
                      "fall has a way of making the kitchen feel like the center of everything.",
                      "the season for gathering together has arrived.",
                      "autumn says it is time to make the ordinary feel a little richer.",
                      "cool-weather living has entered the chat."
                ],
                "winterAhead": [
                      "winter is waiting just outside the door.",
                      "cold nights are making their way in.",
                      "the coziest stretch of the year is nearly here.",
                      "the house is beginning to ask for softer, warmer things.",
                      "the first truly cold night is getting closer.",
                      "winter is on its way, and the house is already nesting.",
                      "the season of staying in is warming up.",
                      "cold-weather rituals are beginning to return.",
                      "the evenings are getting darker and the rooms are getting cozier.",
                      "winter is close enough to start setting the table for.",
                      "the house is preparing for its coziest, softest season.",
                      "the cold is coming — useful comforts are about to earn their keep.",
                      "the year is turning toward slower evenings and warmer rooms.",
                      "cozy season is no longer a rumor.",
                      "winter is almost here. The good mugs are ready.",
                      "the house is about to become everyone’s favorite place again."
                ],
                "holiday": [
                      "the twinkle-light season has arrived.",
                      "the year is winding down, but there’s still room for something lovely.",
                      "the house has officially entered its gathering season.",
                      "a little warmth goes a long way this time of year.",
                      "the good dishes have entered the rotation.",
                      "the season of extra chairs and full tables is here.",
                      "the house is dressed up and expecting company.",
                      "the coziest part of the calendar has officially arrived.",
                      "this is the season for giving useful things beautifully.",
                      "the lights are up. The lists are getting longer.",
                      "holiday hosting has a way of revealing exactly what the house is missing.",
                      "the year is almost wrapped — maybe one more good find.",
                      "gathering season makes every little detail matter.",
                      "the table is about to work harder than usual.",
                      "the house is ready for company, cookies, and one more candle.",
                      "the season has officially become equal parts cozy and chaotic.",
                      "winter gatherings are making the kitchen feel important again.",
                      "the nicest kind of busy season has arrived."
                ]
          },
          "dreamy": [
                "Something lovely may be closer than you think.",
                "A good home is built one small favorite at a time.",
                "Maybe today is for finding the thing you didn’t know you were looking for.",
                "Useful can still be beautiful.",
                "The best rooms usually have a few stories hiding in them.",
                "A tiny change can shift the whole feeling of a room.",
                "There is always room for one more thing that earns its place.",
                "A well-loved home is never finished. That is half the fun.",
                "The things you use every day deserve to be things you like looking at.",
                "Home is made in the little choices no one else notices first.",
                "Some objects make a room feel more like itself.",
                "The right everyday thing can quietly improve everything around it.",
                "A home becomes yours one useful favorite at a time.",
                "Beauty is allowed to have a job.",
                "The ordinary parts of the day deserve good design too.",
                "A room does not need more things. It needs the right things.",
                "Small rituals deserve objects worth reaching for.",
                "Good homes are collected slowly, not finished quickly.",
                "The best pieces feel like they were always meant to be there.",
                "There is a difference between filling a room and finding what belongs in it.",
                "The things that stay are usually the things that quietly work.",
                "A beautiful home is mostly a collection of useful decisions.",
                "Sometimes the smallest change makes a room exhale.",
                "Your everyday deserves a little ceremony.",
                "One good object can make an ordinary routine feel intentional.",
                "The right texture can change the temperature of a room without touching the thermostat.",
                "A shelf is really just a story waiting for better punctuation.",
                "There is something comforting about a thing that is both useful and lovely.",
                "The rooms we love most are usually the ones that feel lived in, not finished.",
                "A home should make ordinary days feel worth coming back to.",
                "Maybe the room is not missing more. Maybe it is missing better.",
                "A good find feels obvious only after you find it.",
                "The quietest pieces are often the ones that make the room.",
                "A little warmth can come from wood, linen, light, or simply choosing well.",
                "Home is where the useful things slowly become sentimental.",
                "A favorite bowl is never just a bowl for very long.",
                "The best everyday objects eventually become part of the family vocabulary.",
                "Rooms remember what we keep reaching for.",
                "A practical thing can still make you happy every time you see it.",
                "There is no rule that says organization has to look organized.",
                "The right object can make a habit easier to keep.",
                "Sometimes better living starts with a better place to put the keys.",
                "A room can feel collected without feeling crowded.",
                "Good design earns its place by making life feel easier.",
                "The goal is not perfect. The goal is a home that feels like yours.",
                "The best homes have evidence of real life everywhere.",
                "A useful thing can still feel like a treat.",
                "The smallest luxuries are often the ones used every day.",
                "A good home has room for beauty and fingerprints.",
                "Nothing has to match perfectly to belong together beautifully.",
                "A room should feel collected, not coordinated.",
                "The best kind of upgrade is one you notice every single day.",
                "There is joy in replacing the almost-right thing with the right one.",
                "Good taste is often just paying attention to the details you live with.",
                "A drawer that works better is a tiny form of peace.",
                "The home you love is hidden inside a hundred small decisions.",
                "One thoughtful object can give a whole corner a reason to exist.",
                "The nicest things are often the ones that quietly solve a problem.",
                "A home should feel like a place where life is allowed to happen.",
                "Choose the thing that makes the everyday version of you happiest.",
                "A useful favorite is still a favorite.",
                "The best pieces become invisible because they simply work.",
                "Sometimes the room knows what it needs before you do.",
                "The right thing does not shout. It settles in.",
                "Make space for the objects that make daily life feel considered.",
                "A beautiful home is less about having more and more about noticing more.",
                "The things within reach shape more of the day than we realize.",
                "A simple thing, chosen well, rarely feels simple for long.",
                "The house does not need perfection. It needs personality.",
                "The goal is a home that feels good before anyone else sees it."
          ],
          "quippy": [
                "The house called. It has notes.",
                "Your cart is technically a design plan.",
                "Consider this highly productive browsing.",
                "The prettier version is still the practical version.",
                "Organization, but make it worth looking at.",
                "Somebody has to have the good kitchen scissors.",
                "You can call it an upgrade if that helps.",
                "A basket has never caused a problem. Probably.",
                "This is research for the house.",
                "The shelf is not going to style itself.",
                "If it has a lid, a handle, or a purpose, we can justify it.",
                "Good taste occasionally requires a cart.",
                "The room was missing something. Convenient.",
                "A tiny upgrade is still an upgrade.",
                "Your future guests will assume you always had it together.",
                "The junk drawer deserves a redemption arc.",
                "The kitchen has enough opinions already. Give it better tools.",
                "This could absolutely count as home maintenance.",
                "A beautiful storage solution is still storage. Case closed.",
                "One more basket and then we are definitely organized.",
                "The table is asking for better accessories.",
                "This is what “just looking” looks like now.",
                "A practical purchase with excellent cheekbones.",
                "Useful, but suspiciously attractive.",
                "The house is enabling you. We are staying neutral.",
                "You did not come here for a new favorite, but here we are.",
                "The good version of the boring thing is rarely boring.",
                "The drawer has had enough chances.",
                "A nice tray can solve more emotional problems than expected.",
                "Put it in a basket and suddenly it is intentional.",
                "A matching lid is a form of adult luxury.",
                "The counter deserves better behavior.",
                "A good hook is basically infrastructure.",
                "If it makes the room calmer, that is practically wellness.",
                "The linen closet has entered its improvement era.",
                "Every house has one cabinet begging for intervention.",
                "This is not clutter if it has a designated vessel.",
                "A good lamp can fix at least three moods.",
                "You cannot buy more counter space, but you can fake it beautifully.",
                "The prettier broom is still a broom. That is fiscal responsibility.",
                "Your mug cabinet believes in abundance.",
                "There is no such thing as too many good bowls. We checked.",
                "The entryway would like to be taken seriously.",
                "This feels cheaper than renovating.",
                "A tiny table upgrade has no business being this satisfying.",
                "We support your oddly specific household search.",
                "The laundry room deserves a personality too.",
                "A nice container is basically diplomacy for clutter.",
                "If it stacks, nests, folds, or hides cords, it has our attention.",
                "The pantry is about to become insufferably pleased with itself.",
                "Some problems really are solved by a better bin.",
                "The guest bathroom has been waiting for this moment.",
                "A small domestic victory is still a victory.",
                "The good towels know who they are.",
                "This is your sign to replace the thing you complain about daily.",
                "A better spatula is not dramatic until you use one.",
                "Your countertop has a vision board.",
                "The shelf said it could handle one more thing.",
                "If it makes cleanup easier, it is practically free time.",
                "We are not saying you need it. The drawer is.",
                "The house has been patient.",
                "One more useful thing and suddenly you are “very organized.”",
                "The good scissors should never be a mystery.",
                "The room wants character. Apparently character ships in a box.",
                "A prettier solution is still a solution.",
                "You can blame the season if anyone asks.",
                "This is less shopping and more domestic problem-solving.",
                "The basket lobby remains undefeated.",
                "A little hardware can have a lot of attitude.",
                "The kitchen drawer has filed a formal request."
          ],
          "fortune": [
                "Something lovely is probably hiding on the next shelf.",
                "A small upgrade has a suspicious way of changing the whole room.",
                "Today’s good idea may have handles, a lid, or excellent storage.",
                "The thing you keep thinking about may be worth another look.",
                "A practical choice can still feel a little magical.",
                "One useful little thing may solve more than it promises.",
                "You are closer to your next favorite than you think.",
                "A beautiful object with a job to do is rarely a bad idea.",
                "Your future self has excellent taste. Conveniently, so do you.",
                "The house has been dropping hints. This may be one of them.",
                "A very good find is allowed to be completely unnecessary.",
                "Tiny luxuries count. Especially the useful ones.",
                "The right thing tends to look obvious once you finally find it.",
                "A shelf somewhere is about to look much better.",
                "Good taste occasionally requires a cart.",
                "Consider this permission to choose the prettier version.",
                "A future guest is going to ask where you found that.",
                "One small domestic problem is about to meet its match.",
                "Your next favorite may be something you use every single day.",
                "The thing you almost skip may be the thing you use most.",
                "A drawer somewhere is about to become significantly less annoying.",
                "The right little upgrade is closer than it looks.",
                "You are one good container away from feeling suspiciously organized.",
                "A practical favorite is still a favorite.",
                "Something here is going to make tomorrow easier.",
                "The house seems to have good timing today.",
                "Your next good idea may be hiding in plain sight.",
                "A room is about to get the detail it did not know it needed.",
                "The object you keep coming back to is trying to tell you something.",
                "A little order is headed your way.",
                "One ordinary routine is about to get noticeably nicer.",
                "Your future counter space thanks you.",
                "A quietly brilliant household solution is in your near future.",
                "Something useful is about to become oddly beloved.",
                "The next thing you add to cart may earn permanent counter status.",
                "A better version of the boring thing is waiting.",
                "The house is about to gain a new easy favorite.",
                "One small purchase may save an unreasonable amount of daily irritation.",
                "Your next “why did I wait so long?” item is getting closer.",
                "A shelf is about to become very photogenic by accident.",
                "The useful thing you want may also happen to be beautiful.",
                "A tiny home victory is in your immediate future.",
                "Something here is going to fit like it was always supposed to be there.",
                "The missing piece may be much smaller than the problem made it seem.",
                "Your next favorite household object has excellent timing.",
                "A little more ease is headed toward your everyday routine.",
                "One good find may quietly become indispensable.",
                "The house is preparing to look unusually pulled together.",
                "A future version of you is going to be very pleased with this decision.",
                "Something practical is about to make you disproportionately happy.",
                "The next shelf you organize may actually stay that way.",
                "A small detail is about to do a lot of work.",
                "The right object is going to make the whole setup make sense.",
                "One corner of the house is about to have a very good day.",
                "You may be closer to “finally fixed that” than you think.",
                "A beautiful solution is waiting for an ordinary problem.",
                "Your next home favorite may be hiding outside the obvious category.",
                "The thing that makes life easier is about to make itself known.",
                "A strangely satisfying upgrade is in your near future.",
                "One little replacement may improve the entire routine.",
                "Your future guests are about to think you are more organized than you are.",
                "A very useful object is about to earn emotional significance.",
                "The house has a surprise recommendation for you.",
                "Something you did not plan to find may be exactly right.",
                "A small shift in the room is about to feel much bigger than expected.",
                "The next useful thing you find may also be the prettiest.",
                "You are due for a household item that overperforms.",
                "One practical purchase is about to feel like a luxury.",
                "The right storage solution is about to find you first.",
                "Sometimes one small choice changes the whole room.",
                "Your next good find has “why is this so satisfying?” energy.",
                "Something here may become the thing you recommend to everyone.",
                "The next object you love might be one you never thought about before.",
                "A little domestic luck is headed your way.",
                "The thing you need may have a much better version waiting.",
                "One everyday task is about to become less annoying.",
                "A little more order may be closer than you think.",
                "The right detail is about to finish the thought.",
                "A future morning is going to go smoother because of something you find today.",
                "Something you find today may make a future dinner much easier.",
                "One small object is about to become part of the household routine.",
                "The house is about to gain something nobody knew it needed.",
                "Your next favorite may come with a very practical purpose.",
                "A tiny upgrade is about to make a surprisingly good first impression.",
                "The next thing you organize may actually stay organized.",
                "A quiet little luxury is closer than you think.",
                "The perfect useful thing is probably not where you first expected to look.",
                "One room is about to feel more finished without becoming more crowded.",
                "The right household object is about to become weirdly important to you.",
                "A better everyday routine is hiding inside a small decision.",
                "The next good thing you find may solve a problem you forgot to complain about.",
                "A beautiful little workhorse is waiting somewhere on these shelves.",
                "Your next “everyone should have one” item is closer than it looks.",
                "A small purchase is about to earn an unreasonable amount of gratitude.",
                "The house may be due for a small breakthrough.",
                "The next useful favorite may be one search away.",
                "Something simple is about to make the room feel considered.",
                "A future cleanup is going to be much easier than usual.",
                "One thoughtful detail is about to make the whole setup feel intentional.",
                "The object you did not know had a better version probably does.",
                "Your next little home victory is already somewhere in the catalog."
          ],
          "discovery": [
                "Search the shelves for something unexpected.",
                "Start with the thing you have been meaning to replace.",
                "Find something useful enough to earn its place.",
                "Look for the better version of the everyday thing.",
                "Find the thing that makes one routine easier.",
                "Start with a room, a problem, or a tiny wish.",
                "Find something beautiful with a job to do.",
                "Search by what the house keeps asking for.",
                "Start with the shelf that never quite works.",
                "Find an everyday object worth noticing.",
                "Look for one small thing that changes the whole setup.",
                "Find the useful thing you will wish you bought sooner.",
                "Search for the thing that earns permanent counter space.",
                "Start with the room you keep thinking about.",
                "Find a practical favorite in the making.",
                "Look for something that solves the annoying little problem.",
                "Find the upgrade nobody sees but you notice every day.",
                "Start with a category and let curiosity do the rest.",
                "Find something that makes home feel more like home.",
                "Search for the detail that finishes the thought.",
                "Find something useful, beautiful, or ideally both.",
                "Start with the drawer that has been testing your patience.",
                "Find the thing that makes cleanup one step easier.",
                "Look for the object that quietly improves the routine.",
                "Find something for the kitchen, table, bath, or wherever else needs help.",
                "Start with what you use every single day.",
                "Find the nicer version of the thing you already need.",
                "Look for a little upgrade with a long useful life.",
                "Find something worth reaching for again and again.",
                "Start with the ordinary thing and make it better.",
                "Find a small solution with suspiciously good style.",
                "Search for something the house can actually use.",
                "Find the item that makes one corner behave better.",
                "Start with a need. Stay for the good-looking version.",
                "Find something that belongs in the everyday rotation.",
                "Look for a useful object with a little personality.",
                "Find the thing that makes the setup finally click.",
                "Start with one room and see where the shelves take you.",
                "Find something small enough to change today.",
                "Look for the thing that quietly earns favorite status.",
                "Find a better home for the things that never seem to have one.",
                "Start with the problem area. We will keep it civilized.",
                "Find the upgrade that feels obvious in hindsight.",
                "Look for something good enough to leave out.",
                "Find the practical thing that does not look practical.",
                "Start with what would make tomorrow easier.",
                "Find one useful little luxury.",
                "Search for the thing you keep borrowing from another room.",
                "Find something that makes the everyday feel more considered.",
                "Start anywhere. Good homes are built that way too."
          ],
          "homeMoments": [
                "Make one drawer behave better.",
                "Give the entryway somewhere to put everything.",
                "Find the bowl that lives on the counter forever.",
                "Make morning coffee feel a little more intentional.",
                "Give the guest bath one good detail.",
                "Find something worthy of the open shelf.",
                "Make the pantry easier to live with.",
                "Upgrade the thing you touch ten times a day.",
                "Find the kitchen tool that finally does the job properly.",
                "Give the table something useful to keep around.",
                "Make cleanup slightly less annoying.",
                "Find the basket that makes clutter look deliberate.",
                "Give the nightstand one less loose object.",
                "Find something that earns a permanent spot by the sink.",
                "Make the laundry room a little less purely functional.",
                "Give the countertop some breathing room.",
                "Find the hook that solves the chair-covered-in-things problem.",
                "Make the cabinet you avoid opening less dramatic.",
                "Find one thing that makes hosting easier.",
                "Give the bathroom counter a better system.",
                "Make the everyday table feel ready without trying too hard.",
                "Find the container that turns “miscellaneous” into a category.",
                "Give the good towels a proper place to live.",
                "Make the fridge door work a little smarter.",
                "Find something that makes the morning rush less chaotic.",
                "Give the coffee corner its missing piece.",
                "Make the junk drawer slightly less committed to the bit.",
                "Find the tray that gathers all the wandering little things.",
                "Give the couch zone one useful improvement.",
                "Make the linen closet feel like it has a plan.",
                "Find the item that makes putting things away easier than leaving them out.",
                "Give the kitchen sink area a small promotion.",
                "Make one shelf look intentionally collected.",
                "Find something that makes weeknight dinner setup faster.",
                "Give the bedside routine one less thing to search for.",
                "Make the home office feel a little less like paperwork lives there.",
                "Find the small thing that makes guests think you planned ahead.",
                "Give the mudroom, hallway, or door-drop zone some structure.",
                "Make the bathroom feel finished without redoing anything.",
                "Find one thing that earns its place on the counter.",
                "Give the pantry a solution you can actually maintain.",
                "Make the shelf useful before styling it.",
                "Find the everyday piece you will eventually buy two of.",
                "Give the kitchen drawer a reason to stop fighting back.",
                "Make the ordinary routine feel just a little nicer.",
                "Find something that works hard enough to stay visible.",
                "Give the table an easy default setting.",
                "Make one household task feel less like a household task.",
                "Find the thing that makes a small space work harder.",
                "Give one overlooked corner a purpose."
          ]
    };

    function toBool(value) {
      return value === 'true';
    }

    function clean(value) {
      return String(value || '').trim();
    }

    function safeCustomerName(value) {
      const name = clean(value);
      if (!name || name.includes('@') || !/[A-Za-z]/.test(name)) return '';
      const blocked = ['customer', 'guest', 'shopper', 'unknown', 'undefined', 'null', 'none', 'n/a', 'na'];
      if (blocked.includes(name.toLowerCase())) return '';
      return name.slice(0, 18);
    }

    function shuffle(list) {
      const output = [...list];
      for (let i = output.length - 1; i > 0; i -= 1) {
        const j = Math.floor(Math.random() * (i + 1));
        [output[i], output[j]] = [output[j], output[i]];
      }
      return output;
    }

    function pick(list) {
      if (!Array.isArray(list) || list.length === 0) return '';
      return list[Math.floor(Math.random() * list.length)];
    }

    function fitList(list, limit) {
      if (!Array.isArray(list)) return [];
      if (!limit || limit < 1) return [...list];
      const fits = list.filter((item) => item.length <= limit);
      return fits.length ? fits : [...list].sort((a, b) => a.length - b.length).slice(0, 1);
    }

    function pickWithinLimit(list, limit) {
      return pick(fitList(list, limit));
    }

    function timePeriod(date) {
      const hour = date.getHours();
      if (hour >= 5 && hour < 12) return 'morning';
      if (hour >= 12 && hour < 17) return 'afternoon';
      if (hour >= 17 && hour < 23) return 'evening';
      return 'late';
    }

    function seasonStage(date) {
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const md = month * 100 + day;

      if (md <= 209) return 'deepWinter';
      if (md <= 319) return 'springAhead';
      if (md <= 509) return 'spring';
      if (md <= 620) return 'summerAhead';
      if (md <= 820) return 'summer';
      if (md <= 920) return 'lateSummer';
      if (md <= 1105) return 'autumn';
      if (md <= 1210) return 'winterAhead';
      return 'holiday';
    }

    function capitalizeSentence(value) {
      if (!value) return '';
      return value.charAt(0).toUpperCase() + value.slice(1);
    }

    function customerLead(period, name) {
      const base = period === 'late' ? 'Still up' : `Good ${period}`;
      return name ? `${base}, ${name}` : base;
    }

    function makePriorityGreeting({ period, stage, name, useCustomer, useTime, useSeasonal, limit }) {
      const seasonalLines = phrases.seasonal[stage] || [];
      const tails = phrases.timeTails[period] || [];
      const lead = useTime ? customerLead(period, useCustomer ? name : '') : (useCustomer && name ? name : '');
      const candidates = [];

      if (useSeasonal && seasonalLines.length) {
        seasonalLines.forEach((line) => {
          candidates.push(lead ? `${lead} — ${line}` : capitalizeSentence(line));
        });
      }

      if (useTime && tails.length) {
        tails.forEach((line) => {
          candidates.push(lead ? `${lead} — ${line}` : capitalizeSentence(line));
        });
      }

      if (!candidates.length && lead) candidates.push(`${lead}.`);
      if (!candidates.length) candidates.push(...phrases.dreamy);
      return pickWithinLimit(candidates, limit);
    }

    function makeRotationPool({ period, stage, name, useCustomer, useTime, useSeasonal }) {
      const pool = [];
      const lead = useTime ? customerLead(period, useCustomer ? name : '') : (useCustomer && name ? name : '');

      if (useSeasonal) {
        (phrases.seasonal[stage] || []).forEach((line) => {
          pool.push(lead ? `${lead} — ${line}` : capitalizeSentence(line));
        });
      }

      if (useTime) {
        (phrases.timeTails[period] || []).forEach((line) => {
          pool.push(lead ? `${lead} — ${line}` : capitalizeSentence(line));
        });
        pool.push(...(phrases.time[period] || []));
      }

      pool.push(...phrases.dreamy, ...phrases.quippy, ...phrases.discovery, ...phrases.homeMoments);
      return [...new Set(pool.filter(Boolean))];
    }

    function formatMoney(cents) {
      if (cents === null || cents === undefined || cents === '') return '';
      const number = Number(cents);
      if (Number.isNaN(number)) return '';
      const currency = window.Shopify?.currency?.active || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency
        }).format(number);
      } catch (error) {
        return `$${number.toFixed(2)}`;
      }
    }

    function escapeHtml(value) {
      return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }

    function productImage(product) {
      return product?.featured_image?.url || product?.image || product?.featured_image || '';
    }

    function renderSection(title, items, renderer) {
      if (!items.length) return '';
      return `
        <section class="new-predictive-section">
          <h3 class="new-predictive-heading">${escapeHtml(title)}</h3>
          <ul class="new-predictive-list">${items.map(renderer).join('')}</ul>
        </section>
      `;
    }

    function renderProduct(product) {
      const image = productImage(product);
      const price = formatMoney(product.price);
      return `
        <li role="option">
          <a class="new-predictive-link" href="${escapeHtml(product.url)}">
            ${image ? `<img class="new-predictive-image" src="${escapeHtml(image)}" alt="" loading="lazy" width="104" height="104">` : ''}
            <span class="new-predictive-meta">
              <span class="new-predictive-title">${escapeHtml(product.title)}</span>
              ${price ? `<span class="new-predictive-subtitle new-predictive-price">${escapeHtml(price)}</span>` : ''}
            </span>
          </a>
        </li>
      `;
    }

    function renderCollection(collection) {
      return `
        <li role="option">
          <a class="new-predictive-link" href="${escapeHtml(collection.url)}">
            <span class="new-predictive-meta">
              <span class="new-predictive-title">${escapeHtml(collection.title)}</span>
              <span class="new-predictive-subtitle">Collection</span>
            </span>
          </a>
        </li>
      `;
    }

    function renderQuery(query) {
      const text = query.styled_text || query.text || query.title || '';
      const raw = query.text || query.title || text.replace(/<[^>]*>/g, '');
      const href = query.url || `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(raw)}&type=product`;
      return `
        <li role="option">
          <a class="new-predictive-link" href="${escapeHtml(href)}">
            <span class="new-predictive-meta">
              <span class="new-predictive-title">${escapeHtml(raw)}</span>
              <span class="new-predictive-subtitle">Suggested search</span>
            </span>
          </a>
        </li>
      `;
    }

    function storageGet(key) {
      try { return sessionStorage.getItem(key); } catch (error) { return null; }
    }

    function storageSet(key, value) {
      try { sessionStorage.setItem(key, value); } catch (error) { /* storage can be unavailable */ }
    }

    function initSearch(root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const input = root.querySelector('.search-page-input');
      const panel = root.querySelector('[data-new-predictive]');
      const reset = root.querySelector('[data-new-search-reset]');
      const greetingEl = root.querySelector('[data-new-search-greeting]');
      const fortuneEl = root.querySelector('[data-new-search-fortune]');
      const autoPlaceholder = root.querySelector('[data-new-auto-placeholder]');
      const autoPlaceholderText = root.querySelector('[data-new-auto-placeholder-text]');

      const placeholderMode = clean(root.dataset.placeholderMode || 'text').toLowerCase();
      const staticPlaceholder = root.dataset.placeholderText || '';
      const autoTypingSpeed = Math.max(20, Number(root.dataset.autoTypingSpeed || 90));
      const autoDeletingSpeed = Math.max(10, Number(root.dataset.autoDeletingSpeed || 50));
      const autoPhrasePause = Math.max(500, Number(root.dataset.autoPhrasePause || 2250));
      const showAutoCursor = toBool(root.dataset.autoCursor);
      const autoPhrasePool = [...new Set(
        String(root.dataset.autoPhrases || '')
          .split('||')
          .map(clean)
          .filter((phrase) => phrase && phrase.length <= 64)
      )];

      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const now = new Date();
      const period = timePeriod(now);
      const stage = seasonStage(now);
      const isHomepage = toBool(root.dataset.isHomepage);
      const useCustomer = toBool(root.dataset.enableCustomer);
      const useTime = toBool(root.dataset.enableTime);
      const useSeasonal = toBool(root.dataset.enableSeasonal);
      const useFortune = toBool(root.dataset.enableFortune);
      const autoRotate = toBool(root.dataset.autoRotate);
      const rotationDelay = Math.max(3, Number(root.dataset.rotationDelay || 10)) * 1000;
      const phraseLimit = mobile ? Number(root.dataset.mobilePhraseCharLimit || 0) : 0;
      const name = safeCustomerName(root.dataset.customerName || '');

      const prioritySeen = storageGet(SESSION_KEY) === 'true';
      const priority = isHomepage && toBool(root.dataset.firstHomePriority) && !prioritySeen;

      const rotationPool = fitList(makeRotationPool({
        period,
        stage,
        name,
        useCustomer,
        useTime,
        useSeasonal
      }), phraseLimit);

      let greetingDeck = shuffle(rotationPool);
      let fortuneDeck = shuffle(fitList(phrases.fortune, phraseLimit));
      let lastGreeting = '';
      let lastFortune = '';

      const takeNext = (deckName) => {
        let deck = deckName === 'fortune' ? fortuneDeck : greetingDeck;
        const source = deckName === 'fortune' ? fitList(phrases.fortune, phraseLimit) : rotationPool;
        const last = deckName === 'fortune' ? lastFortune : lastGreeting;

        if (!deck.length) deck = shuffle(source);
        let next = deck.shift() || '';
        if (next === last && deck.length) {
          deck.push(next);
          next = deck.shift() || next;
        }

        if (deckName === 'fortune') {
          fortuneDeck = deck;
          lastFortune = next;
        } else {
          greetingDeck = deck;
          lastGreeting = next;
        }
        return next;
      };

      if (greetingEl && toBool(root.dataset.enableGreeting)) {
        const initialGreeting = priority
          ? makePriorityGreeting({ period, stage, name, useCustomer, useTime, useSeasonal, limit: phraseLimit })
          : takeNext('greeting');
        greetingEl.textContent = initialGreeting;
        lastGreeting = initialGreeting;
        if (priority) storageSet(SESSION_KEY, 'true');
      }

      if (fortuneEl && useFortune) {
        fortuneEl.textContent = takeNext('fortune');
      }

      let rotationTimer = null;
      const rotateCopy = () => {
        if (document.hidden) return;
        if (greetingEl && toBool(root.dataset.enableGreeting)) {
          const nextGreeting = takeNext('greeting');
          if (nextGreeting) greetingEl.textContent = nextGreeting;
        }
        if (fortuneEl && useFortune) {
          const nextFortune = takeNext('fortune');
          if (nextFortune) fortuneEl.textContent = nextFortune;
        }
      };

      if (autoRotate && (greetingEl || fortuneEl)) {
        rotationTimer = window.setInterval(rotateCopy, rotationDelay);
      }

      let autoTypeTimer = null;

      const clearAutoTypeTimer = () => {
        if (autoTypeTimer) {
          window.clearTimeout(autoTypeTimer);
          autoTypeTimer = null;
        }
      };

      const syncSearchValueState = () => {
        if (!input) return false;
        const hasValue = input.value.length > 0;
        root.classList.toggle('has-search-value', hasValue);

        if (autoPlaceholder) {
          autoPlaceholder.hidden = placeholderMode !== 'auto' || hasValue;
        }

        return hasValue;
      };

      const initializeAutoPlaceholder = () => {
        if (!input || !autoPlaceholder || !autoPlaceholderText) return;

        autoPlaceholder.classList.toggle('no-auto-cursor', !showAutoCursor);

        if (placeholderMode === 'text') {
          clearAutoTypeTimer();
          input.placeholder = staticPlaceholder;
          autoPlaceholder.hidden = true;
          autoPlaceholderText.textContent = '';
          return;
        }

        if (placeholderMode === 'none') {
          clearAutoTypeTimer();
          input.placeholder = '';
          autoPlaceholder.hidden = true;
          autoPlaceholderText.textContent = '';
          return;
        }

        input.placeholder = '';
        syncSearchValueState();

        const phrasesForTyping = autoPhrasePool.length
          ? shuffle(autoPhrasePool)
          : ['Search the shelves…', 'What are you looking for?', 'Find something new…'];

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          autoPlaceholderText.textContent = phrasesForTyping[0] || 'Search the shelves…';
          return;
        }

        let phraseIndex = 0;
        let characterIndex = 0;
        let deleting = false;

        const scheduleAutoType = (callback, delay) => {
          clearAutoTypeTimer();
          autoTypeTimer = window.setTimeout(callback, delay);
        };

        const stepAutoType = () => {
          if (!document.body.contains(root)) {
            clearAutoTypeTimer();
            return;
          }

          if (syncSearchValueState()) {
            clearAutoTypeTimer();
            return;
          }

          const phrase = phrasesForTyping[phraseIndex] || phrasesForTyping[0] || 'Search the shelves…';
          autoPlaceholder.hidden = false;

          if (!deleting) {
            characterIndex += 1;
            autoPlaceholderText.textContent = phrase.slice(0, characterIndex);

            if (characterIndex >= phrase.length) {
              characterIndex = phrase.length;
              deleting = true;
              scheduleAutoType(stepAutoType, autoPhrasePause);
              return;
            }

            scheduleAutoType(stepAutoType, autoTypingSpeed);
            return;
          }

          characterIndex -= 1;
          autoPlaceholderText.textContent = phrase.slice(0, Math.max(0, characterIndex));

          if (characterIndex <= 0) {
            characterIndex = 0;
            deleting = false;
            phraseIndex = (phraseIndex + 1) % phrasesForTyping.length;
            scheduleAutoType(stepAutoType, 450);
            return;
          }

          scheduleAutoType(stepAutoType, autoDeletingSpeed);
        };

        autoPlaceholderText.textContent = '';
        scheduleAutoType(stepAutoType, 500);
      };

      root.addEventListener('shopify:section:unload', () => {
        if (rotationTimer) window.clearInterval(rotationTimer);
        clearAutoTypeTimer();
      }, { once: true });

      if (!input) return;

      syncSearchValueState();
      initializeAutoPlaceholder();

      input.addEventListener('input', () => {
        const hasValue = syncSearchValueState();

        if (placeholderMode === 'auto') {
          if (hasValue) {
            clearAutoTypeTimer();
          } else {
            initializeAutoPlaceholder();
          }
        }
      });

      reset?.addEventListener('click', (event) => {
        event.preventDefault();
        input.value = '';
        syncSearchValueState();

        if (panel) {
          panel.hidden = true;
          panel.innerHTML = '';
          input.setAttribute('aria-expanded', 'false');
        }

        if (placeholderMode === 'auto') {
          initializeAutoPlaceholder();
        }

        input.focus();
      });

      if (!panel || !toBool(root.dataset.enablePredictive)) return;

      let controller = null;
      let timer = null;

      const closePanel = () => {
        panel.hidden = true;
        panel.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      };

      const openPanel = () => {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };

      const getLimits = () => ({
        products: Number(root.dataset.desktopProductLimit || 6),
        collections: Number(root.dataset.desktopCollectionLimit || 3),
        queries: Number(root.dataset.desktopQueryLimit || 4)
      });

      const runSearch = async () => {
        const term = input.value.trim();
        if (term.length < 2) {
          closePanel();
          return;
        }

        if (controller) controller.abort();
        controller = new AbortController();

        const rootUrl = window.Shopify?.routes?.root || '/';
        const params = new URLSearchParams();
        params.set('q', term);
        params.set('resources[type]', 'product,collection,query');
        params.set('resources[limit]', '10');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,body,product_type,tag,vendor,variants.title');

        try {
          const response = await fetch(`${rootUrl}search/suggest.json?${params.toString()}`, {
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

          const data = await response.json();
          const results = data?.resources?.results || {};
          const limits = getLimits();
          const products = (results.products || []).slice(0, limits.products);
          const collections = (results.collections || []).slice(0, limits.collections);
          const queries = (results.queries || []).slice(0, limits.queries);

          if (!products.length && !collections.length && !queries.length) {
            panel.innerHTML = '<p class="new-predictive-empty">Nothing yet — try another word or two.</p>';
            openPanel();
            return;
          }

          const viewAllUrl = `${rootUrl}search?type=product&q=${encodeURIComponent(term)}`;
          panel.innerHTML = [
            renderSection('Suggested searches', queries, renderQuery),
            renderSection('Collections', collections, renderCollection),
            renderSection('Products', products, renderProduct),
            `<a class="new-predictive-view-all" href="${escapeHtml(viewAllUrl)}">See all results for “${escapeHtml(term)}”</a>`
          ].join('');
          openPanel();
        } catch (error) {
          if (error.name !== 'AbortError') closePanel();
        }
      };

      input.addEventListener('input', () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(runSearch, 180);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePanel();
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && panel.innerHTML.trim()) openPanel();
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) closePanel();
      });
    }

    function initAll() {
      document.querySelectorAll(SELECTOR).forEach(initSearch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-intelligent-search-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const SELECTOR = '[data-new-search]';
    const SESSION_KEY = 'new-search-home-priority-seen';

    const phrases = {
          "time": {
                "morning": [
                      "Good morning — let’s find something lovely.",
                      "Good morning — fresh day, fresh shelves.",
                      "Morning looks good on you.",
                      "Good morning — a small delight seems reasonable.",
                      "A fresh day deserves a good find.",
                      "Good morning — the shelves are ready when you are.",
                      "Morning light, open shelves, good possibilities.",
                      "Good morning — start with something that earns its place.",
                      "The day is young. Your cart can be too.",
                      "Good morning — find one thing that makes today nicer."
                ],
                "afternoon": [
                      "Good afternoon — let’s find something lovely.",
                      "Good afternoon — consider this a productive detour.",
                      "Still plenty of day for a good find.",
                      "A little afternoon wandering sounds right.",
                      "Good afternoon — something interesting might be waiting.",
                      "The afternoon could use one good discovery.",
                      "Good afternoon — the shelves have a few ideas.",
                      "A useful little detour? Absolutely.",
                      "Good afternoon — maybe the house has a request.",
                      "There is still time to find just the thing."
                ],
                "evening": [
                      "Good evening — the browsing can begin.",
                      "Good evening — something cozy seems appropriate.",
                      "Evening is a fine time to wander the shelves.",
                      "The day is winding down. The browsing does not have to.",
                      "Good evening — let’s find something worth bringing home.",
                      "The errands are over. The interesting part can start.",
                      "Good evening — the house gets a vote now.",
                      "A slower hour deserves a better browse.",
                      "Tonight is a good night for useful little luxuries.",
                      "Good evening — one lovely thing might be enough."
                ],
                "late": [
                      "Still up? The shelves are too.",
                      "A little late-night wandering never hurt.",
                      "The sensible decisions can wait until morning.",
                      "Late-night browsing has excellent taste.",
                      "One more look before tomorrow.",
                      "Still awake? Something good might be hiding here.",
                      "The house is quiet. The wishlist is not.",
                      "Late-night finds have a way of feeling meant to be.",
                      "Still up? Call it research.",
                      "One more scroll. We will not tell."
                ]
          },
          "timeTails": {
                "morning": [
                      "plenty of day left to find something lovely.",
                      "the day has barely started, and the shelves are already tempting.",
                      "a small delight seems like a reasonable way to begin.",
                      "fresh coffee, fresh light, fresh possibilities.",
                      "the house is waking up too.",
                      "one useful little upgrade could set the tone.",
                      "today has room for something beautiful and useful.",
                      "this is a good hour to find an everyday favorite."
                ],
                "afternoon": [
                      "there’s still plenty of day for a good find.",
                      "consider this your productive little detour.",
                      "the afternoon could use something interesting.",
                      "a little browsing feels perfectly justified.",
                      "one good find can improve the rest of the day.",
                      "there is still time for a small home reset.",
                      "the day could use a prettier practical decision.",
                      "the house may be ready for one small change."
                ],
                "evening": [
                      "the errands are over. The wandering can begin.",
                      "something cozy feels especially appropriate now.",
                      "the house is quiet enough to notice what it wants next.",
                      "this feels like a good hour to find something lovely.",
                      "one useful little luxury sounds about right.",
                      "staying in could always feel a little better.",
                      "the house has your attention at last.",
                      "this is prime time for a small cozy upgrade."
                ],
                "late": [
                      "the shelves are still awake too.",
                      "a little late-night wandering never hurt.",
                      "the sensible decisions can wait until morning.",
                      "maybe the best finds happen after everyone else logs off.",
                      "the house is quiet enough to make its case.",
                      "your future self can review the cart tomorrow.",
                      "this hour has excellent browsing energy.",
                      "the wishlist has the floor."
                ]
          },
          "seasonal": {
                "deepWinter": [
                      "winter is asking the house to soften a little.",
                      "the cold days are still here, so cozy gets another turn.",
                      "the season for staying in is still making its case.",
                      "warm corners and useful little comforts are having a moment.",
                      "winter is not finished with the blankets yet.",
                      "cold mornings make a strong argument for better everyday comforts.",
                      "the house is doing its best hibernation impression.",
                      "there is still time to lean all the way into cozy.",
                      "winter has a way of making useful comforts feel luxurious.",
                      "soft light and warm little rituals are carrying the season.",
                      "the cold is staying. The clutter does not have to.",
                      "a warm home is built in very small decisions."
                ],
                "springAhead": [
                      "spring is starting to make plans.",
                      "longer days are quietly finding their way back.",
                      "the house might be ready for its first little thaw.",
                      "winter is loosening its grip, one bright corner at a time.",
                      "the first hints of spring are starting to show.",
                      "lighter days are almost back on the schedule.",
                      "the house is beginning to ask for a reset.",
                      "open-window season is getting closer.",
                      "spring is not here yet, but it has definitely sent a note.",
                      "the heavy season is starting to lift.",
                      "fresh starts are creeping back into the conversation.",
                      "the first little signs of spring are enough to make plans around."
                ],
                "spring": [
                      "spring has the windows asking to be opened.",
                      "a lighter season deserves a lighter little reset.",
                      "the house is waking up along with everything outside.",
                      "fresh-air season has officially entered the chat.",
                      "spring is making a very convincing case for clearing a shelf.",
                      "the brighter days are making everything look ready for a refresh.",
                      "this season likes things light, useful, and easy.",
                      "a fresh corner can change the whole room in spring.",
                      "the season of open doors and cleared counters is here.",
                      "spring cleaning is easier with something pretty waiting at the end.",
                      "the house wants a little breathing room.",
                      "spring is a good excuse to make everyday things feel new again."
                ],
                "summerAhead": [
                      "summer is warming up in the wings.",
                      "long days and easy evenings are almost here.",
                      "the easy season is starting to show itself.",
                      "summer plans are beginning to look suspiciously real.",
                      "the porch, patio, and table are about to get busier.",
                      "warm evenings are almost back in rotation.",
                      "the house is getting ready to live a little more casually.",
                      "summer is close enough to start setting the table for it.",
                      "long-weekend energy is beginning to arrive.",
                      "the season of open doors and cold drinks is almost here.",
                      "easy entertaining weather is on the way.",
                      "summer is close enough to shop like it."
                ],
                "summer": [
                      "summer is still making a very good case for itself.",
                      "long days call for easy, useful things.",
                      "the windows are open and the house feels lighter.",
                      "summer has the shelves feeling a little more relaxed.",
                      "the season of easy dinners and open doors is in full swing.",
                      "summer likes anything that makes life a little simpler.",
                      "warm nights are asking for a better table and less fuss.",
                      "the house is in its barefoot era.",
                      "summer is for the things you reach for without thinking.",
                      "long light makes the small details easier to notice.",
                      "keep it useful, keep it easy, keep summer going.",
                      "the best summer things tend to earn permanent shelf space."
                ],
                "lateSummer": [
                      "summer’s nearly packed its bags.",
                      "autumn is starting to knock.",
                      "the cozy season is creeping closer.",
                      "summer had a good run — autumn is waiting in the wings.",
                      "the light is changing already.",
                      "cooler days are coming. The house might want a head start.",
                      "consider this your first little nudge toward autumn.",
                      "almost sweater weather. Almost.",
                      "summer is winding down, but the good part of the year is not.",
                      "the first cozy thoughts are starting to sneak in.",
                      "autumn is close enough to start clearing a little shelf space.",
                      "the evenings are getting just short enough to notice.",
                      "late summer is starting to look a lot like early autumn planning.",
                      "the sun is still warm, but the house is thinking ahead.",
                      "we are entering the season of one-more-blanket decisions.",
                      "summer is softening around the edges.",
                      "cool mornings are not far off now.",
                      "the first hint of autumn is usually all it takes.",
                      "the calendar still says summer. The shelves are unconvinced.",
                      "autumn has not arrived, but it has definitely been browsing."
                ],
                "autumn": [
                      "autumn has officially moved in.",
                      "the house is entering its cozy era.",
                      "cool mornings are making everything feel a little more intentional.",
                      "this is the season for warm corners and good things within reach.",
                      "autumn is making the kitchen feel important again.",
                      "the season of lamps, layers, and longer dinners is here.",
                      "cooler air makes every room want a little warmth.",
                      "the house is ready for its richer textures.",
                      "autumn is permission to make everyday rituals feel special.",
                      "the cozy details are officially doing the heavy lifting.",
                      "this is a good season to make home the destination.",
                      "warm drinks, low light, useful little luxuries — right on time."
                ],
                "winterAhead": [
                      "winter is waiting just outside the door.",
                      "cold nights are making their way in.",
                      "the coziest stretch of the year is nearly here.",
                      "the house is beginning to ask for softer, warmer things.",
                      "the first truly cold evening is closer than it looks.",
                      "gathering season is starting to take shape.",
                      "the house is quietly preparing for longer nights.",
                      "warm light is about to become very important.",
                      "winter is close enough to start making room for comfort.",
                      "the season of staying in is warming up.",
                      "cold-weather rituals are about to take over the kitchen.",
                      "the year is moving toward its coziest chapter."
                ],
                "holiday": [
                      "the twinkle-light season has arrived.",
                      "the year is winding down, but there’s still room for something lovely.",
                      "the house has officially entered its gathering season.",
                      "a little warmth goes a long way this time of year.",
                      "company is coming, eventually. The house knows.",
                      "the table is about to become the main character.",
                      "giftable little things are suddenly looking very persuasive.",
                      "the season of wrapping, gathering, and one-more-chair is here.",
                      "the house is dressed for its busiest month.",
                      "this is the time of year when useful gifts quietly win.",
                      "the kitchen is about to work overtime.",
                      "the coziest month deserves the nicest everyday things."
                ]
          },
          "dreamy": [
                "Something lovely may be closer than you think.",
                "A good home is built one small favorite at a time.",
                "Maybe today is for finding the thing you didn’t know you needed.",
                "Useful can still be beautiful.",
                "The best rooms usually have a few stories hiding in them.",
                "A tiny change can shift the whole feeling of a room.",
                "There is always room for one more thing that earns its place.",
                "A well-loved home is never finished. That is half the fun.",
                "Find something that makes the everyday feel a little better.",
                "The right detail can make the whole room exhale.",
                "Home is mostly a collection of little choices that felt right.",
                "The things you use every day deserve to be the things you love.",
                "A beautiful ordinary life is still a beautiful life.",
                "Sometimes the smallest object changes the whole ritual.",
                "Make room for the things that make home feel more like yours.",
                "There is something wonderful about an object that earns its keep.",
                "A quiet upgrade can change the mood without changing the room.",
                "Good design should make the ordinary feel considered.",
                "The best finds are the ones you start reaching for automatically.",
                "Your home does not need more things. It needs better favorites.",
                "A little beauty in the everyday is never wasted.",
                "The right object can make a routine feel like a ritual.",
                "Home gets better when the useful things feel chosen.",
                "A small favorite can become part of the story surprisingly fast.",
                "The nicest homes feel collected, not completed.",
                "Find something that looks like it has always belonged there.",
                "Some things make a room prettier. Some make life easier. The best do both.",
                "A calm room often starts with one thoughtful choice.",
                "There is no rush to finish a home worth living in.",
                "Find the piece that makes the whole corner make sense.",
                "The everyday deserves a little ceremony too.",
                "The objects around you quietly shape the way a day feels.",
                "A beautiful home is allowed to be practical.",
                "Keep the things that make ordinary moments feel considered.",
                "The right find feels less like shopping and more like recognition.",
                "A room becomes yours one useful favorite at a time.",
                "Somewhere between useful and beautiful is usually the sweet spot.",
                "Find something that makes putting it away almost as nice as using it.",
                "The best everyday things make themselves missed when they are gone.",
                "Choose the thing you will be glad to see again tomorrow.",
                "Home is where small details get to matter.",
                "The right thing can make an old routine feel new.",
                "A room can feel different before anything major changes.",
                "Let the house collect its personality slowly.",
                "Beautiful utility is still one of life’s best little luxuries.",
                "Find the kind of thing that makes you wonder how you managed without it.",
                "Some favorites announce themselves. Others quietly become indispensable.",
                "The shelves do not need filling. They need choosing.",
                "A thoughtful home is made in inches, not overhauls.",
                "The best kind of luxury is the kind you actually use."
          ],
          "quippy": [
                "Search the shelves. See what finds you.",
                "Something useful. Something beautiful. Maybe both.",
                "What is the house asking for today?",
                "Looking for something special?",
                "A little something for home?",
                "Find your next everyday favorite.",
                "What are we hunting for today?",
                "Let’s find just the thing.",
                "Browse first. Explain the cart later.",
                "The shelves have ideas.",
                "Need it? Love it? Excellent start.",
                "Practical can have good taste too.",
                "The house called. It has notes.",
                "You came for one thing. We respect the optimism.",
                "A very normal amount of browsing starts here.",
                "Find the thing that fixes the oddly specific problem.",
                "The prettier version is still practical.",
                "Good shelves encourage bad restraint.",
                "Search by need. Stay for the want.",
                "One useful thing can lead to several useful things. Science.",
                "The cart is merely a holding area for possibilities.",
                "Consider this organized curiosity.",
                "Start with the room that is currently bothering you.",
                "We support highly specific household missions.",
                "There is probably a basket for that.",
                "A better drawer is closer than you think.",
                "A tiny upgrade is still an upgrade.",
                "The kitchen has opinions. Let’s hear them.",
                "Your future junk drawer is rooting for you.",
                "The good version of the boring thing is in here somewhere.",
                "Beautiful and useful is not asking too much.",
                "Start broad. Get suspiciously specific later.",
                "The shelf space can be negotiated.",
                "A cart is just a very organized wishlist.",
                "Find the thing that makes you say, finally.",
                "Your cabinets deserve better coworkers.",
                "Search by problem. We will aim for a pretty solution.",
                "The house is not judging. The drawer might be.",
                "Let’s make one corner less irritating.",
                "A little utility with excellent manners.",
                "The right tool can be ridiculously satisfying.",
                "You are allowed to replace the ugly useful thing.",
                "Search the wares. Make a case for the cart.",
                "Find something worth leaving on the counter.",
                "A household problem is just a search term in disguise.",
                "Good taste has entered the utility closet.",
                "A better version probably exists. Let’s find it.",
                "Searching is cheaper than remodeling.",
                "Your home improvement era can be extremely small-scale.",
                "We believe in useful things with unnecessary charm."
          ],
          "fortune": [
                "Something lovely is probably hiding on the next shelf.",
                "A small upgrade has a suspicious way of changing the whole room.",
                "Today’s good idea may have handles, a lid, or excellent storage.",
                "The thing you keep thinking about is becoming less accidental.",
                "A practical choice can still feel a little magical.",
                "One useful little thing may solve more than it promises.",
                "You are closer to your next favorite than you think.",
                "A beautiful object with a job to do is rarely a bad idea.",
                "Your future self has excellent taste. Conveniently, so do you.",
                "The house has been dropping hints. This may be one of them.",
                "A very good find is allowed to be completely unnecessary.",
                "Tiny luxuries count. Especially the useful ones.",
                "The right thing tends to look obvious once you finally find it.",
                "A shelf somewhere is about to look much better.",
                "Good taste occasionally requires a cart.",
                "Consider this permission to choose the prettier version.",
                "A drawer is about to become strangely satisfying.",
                "Something you buy for function will become a favorite for form.",
                "The useful thing you almost skip may be the one you use most.",
                "A better morning is hiding in one small household decision.",
                "Your next favorite may not look important at first.",
                "Today favors things that are useful twice over.",
                "The house is quietly voting yes.",
                "A small object is about to make an unreasonable difference.",
                "Your next good decision may be dishwasher safe.",
                "Something here will make you wonder why you waited.",
                "A practical upgrade is about to feel suspiciously luxurious.",
                "The next thing you reach for every day might be in here.",
                "A prettier routine is closer than you think.",
                "Your shelves are entering a more organized chapter.",
                "One good container may restore your faith in the cabinet.",
                "A future guest is going to ask where you found that.",
                "The right little thing will make the whole setup click.",
                "Something simple is about to become indispensable.",
                "Your next favorite may solve a problem you stopped noticing.",
                "A better version of the boring thing is in your future.",
                "One shelf is about to get promoted.",
                "You are approaching a very satisfying before-and-after.",
                "The house knows what it wants. It is being subtle about it.",
                "A useful gift is about to make you look unusually thoughtful.",
                "A small purchase is about to earn a lot of mileage.",
                "The thing you came for may not be the thing you leave with.",
                "A good kitchen decision is on the horizon.",
                "Your future counter space looks remarkably composed.",
                "The next thing that makes you say finally is nearby.",
                "A routine is about to become a little less annoying.",
                "The prettier option is going to prove its case.",
                "A useful little luxury is headed your way.",
                "Your next organizing victory may fit in one hand.",
                "The house has excellent timing today.",
                "A small fix is about to feel like a major improvement.",
                "Something here may become the thing you recommend to everyone.",
                "A good home decision is quietly waiting for you.",
                "Your future self will appreciate the better version.",
                "Something ordinary is about to become oddly delightful.",
                "Your next favorite may come with a lid.",
                "A tiny household win is in your near future.",
                "A good find may make the old version suddenly unacceptable.",
                "Something here is about to become part of the routine.",
                "Your next useful obsession is closer than expected.",
                "A better table moment is on the way.",
                "The house is ready for one thoughtful little upgrade.",
                "You are one search away from solving a very specific annoyance.",
                "A lovely practical thing is about to earn its keep.",
                "Your next everyday favorite will look obvious in hindsight.",
                "The cabinet is about to lose an argument.",
                "A useful thing is going to make you disproportionately happy.",
                "The next good idea may be stackable.",
                "Your home is about to get one percent more put together.",
                "A little order is on its way to one chaotic corner.",
                "A future dinner is going to be easier because of this search.",
                "A small piece of the house is about to make more sense.",
                "The answer to an oddly specific home problem is getting closer.",
                "One useful detail will pull more weight than expected.",
                "A better everyday is hiding in the details.",
                "A future morning is already grateful.",
                "Your next favorite may be the thing that simply works.",
                "The shelves predict a good decision.",
                "A useful little upgrade is about to become nonnegotiable.",
                "Something here will quietly make the room feel more like yours.",
                "A very specific household problem is about to meet its match.",
                "Your next practical purchase has excellent favorite potential."
          ],
          "discovery": [
                "Search the shelves…",
                "What can we help you find?",
                "Find something for the kitchen, home, or table.",
                "Browse by what you need.",
                "Find something worth keeping.",
                "Start with a room.",
                "Start with a problem.",
                "Start with something you have been meaning to replace.",
                "Find something for everyday use.",
                "Search by material, room, use, or style.",
                "What is missing from your home?",
                "Find something that works harder.",
                "Look for the better version.",
                "Find a useful gift.",
                "Search for something small but mighty.",
                "Find something made to be used.",
                "What needs an upgrade?",
                "Search for the thing you keep borrowing.",
                "Find something worthy of the countertop.",
                "Browse the useful things first.",
                "Search by kitchen, bath, storage, table, or gift.",
                "Find an everyday essential with better manners.",
                "Search for a thoughtful housewarming gift.",
                "Find something that solves a small problem well.",
                "What would make the room work better?",
                "Find something that belongs in daily rotation.",
                "Search for a better basic.",
                "Find something useful enough to become a favorite.",
                "What have you been meaning to organize?",
                "Search for the upgrade you keep putting off.",
                "Find something that makes hosting easier.",
                "Search for a practical gift that does not feel practical.",
                "Find something for slow mornings.",
                "Find something for easy dinners.",
                "Search for a small-space solution.",
                "Find something worth clearing a shelf for.",
                "Search for the thing that makes cleanup easier.",
                "Find something for the next gathering.",
                "Search for a kitchen favorite in the making.",
                "Find something for the bathroom that deserves to be seen."
          ],
          "homeMoments": [
                "Make breakfast feel a little less rushed.",
                "Find something for the slow Sunday version of you.",
                "Make the kitchen easier to live in.",
                "Find something for the table before company arrives.",
                "Make one drawer behave better.",
                "Find something for the corner that never quite works.",
                "Make cleanup feel less like a second job.",
                "Find something that makes hosting look easier than it was.",
                "Make the pantry easier to understand at a glance.",
                "Find something for the coffee ritual.",
                "Make the sink area look intentional.",
                "Find something that makes leftovers feel organized.",
                "Make the bathroom counter earn its keep.",
                "Find something for a better bedside routine.",
                "Make everyday storage a little nicer to look at.",
                "Find something for the guest who always stays longer.",
                "Make the table feel ready before the food is.",
                "Find something for the morning rush.",
                "Make the after-dinner reset easier.",
                "Find something for the open-shelf era.",
                "Make a small kitchen feel smarter.",
                "Find something for the housewarming pile.",
                "Make a useful gift feel thoughtful.",
                "Find something for the next rainy day in.",
                "Make the entryway less chaotic.",
                "Find something that makes a small space work harder.",
                "Make the everyday setup feel a little more finished.",
                "Find something for the first chilly morning.",
                "Make summer cleanup easier.",
                "Find something for autumn dinners.",
                "Make holiday hosting one step less dramatic.",
                "Find something for the friend who has everything.",
                "Make the ordinary Tuesday dinner feel nicer.",
                "Find something that makes fresh flowers easier to justify.",
                "Make the cabinet you avoid opening less exciting.",
                "Find something for the baking phase that may or may not last.",
                "Make the laundry room slightly less offensive.",
                "Find something that makes the fridge look like it has a plan.",
                "Make the countertop work without looking crowded.",
                "Find something for the nightly wind-down."
          ]
    };

    function toBool(value) {
      return value === 'true';
    }

    function sessionHas(key) {
      try {
        return window.sessionStorage.getItem(key) === 'true';
      } catch (error) {
        return false;
      }
    }

    function sessionSet(key) {
      try {
        window.sessionStorage.setItem(key, 'true');
      } catch (error) {
        /* Storage can be blocked in some theme-editor/browser contexts. */
      }
    }

    function clean(value) {
      return String(value || '').trim();
    }

    function pick(list) {
      if (!Array.isArray(list) || list.length === 0) return '';
      return list[Math.floor(Math.random() * list.length)];
    }

    function unique(list) {
      return [...new Set(list.filter(Boolean))];
    }

    function shuffle(list) {
      const copy = [...list];
      for (let index = copy.length - 1; index > 0; index -= 1) {
        const swapIndex = Math.floor(Math.random() * (index + 1));
        [copy[index], copy[swapIndex]] = [copy[swapIndex], copy[index]];
      }
      return copy;
    }

    function buildPromptQueue(list, limit, exclude = '') {
      const source = unique(list).filter((item) => item !== exclude);
      if (!source.length) return [];
      if (!limit || limit < 1) return shuffle(source);

      const fits = source.filter((item) => item.length <= limit);
      if (fits.length) return shuffle(fits);

      const shortest = [...source].sort((a, b) => a.length - b.length)[0];
      return shortest ? [shortest] : [];
    }

    function pickWithinLimit(list, limit, exclude = '') {
      const source = unique(list).filter((item) => item !== exclude);
      if (!source.length) return exclude || '';
      if (!limit || limit < 1) return pick(source);

      const fits = source.filter((item) => item.length <= limit);
      if (fits.length) return pick(fits);

      return [...source].sort((a, b) => a.length - b.length)[0];
    }

    function capitalizeSentence(value) {
      const text = clean(value);
      if (!text) return '';
      return text.charAt(0).toUpperCase() + text.slice(1);
    }

    function safeCustomerName(value) {
      const name = clean(value);
      if (!name || name.includes('@') || name.length > 20) return '';
      if (!/[a-zA-Z]/.test(name)) return '';

      const blocked = ['customer', 'guest', 'shopper', 'unknown', 'none', 'null', 'undefined', 'n/a', 'na'];
      if (blocked.includes(name.toLowerCase())) return '';

      return name;
    }

    function timePeriod(date) {
      const hour = date.getHours();
      if (hour >= 5 && hour < 12) return 'morning';
      if (hour >= 12 && hour < 17) return 'afternoon';
      if (hour >= 17 && hour < 23) return 'evening';
      return 'late';
    }

    function seasonStage(date) {
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const md = month * 100 + day;

      if (md <= 209) return 'deepWinter';
      if (md <= 319) return 'springAhead';
      if (md <= 509) return 'spring';
      if (md <= 620) return 'summerAhead';
      if (md <= 820) return 'summer';
      if (md <= 920) return 'lateSummer';
      if (md <= 1105) return 'autumn';
      if (md <= 1210) return 'winterAhead';
      return 'holiday';
    }

    function customerLead(period, name) {
      const base = period === 'late' ? 'Still up' : `Good ${period}`;
      return name ? `${base}, ${name}` : base;
    }

    function buildPriorityCandidates({ period, stage, name, useCustomer, useTime, useSeasonal }) {
      const candidates = [];
      const seasonal = phrases.seasonal[stage] || [];
      const timeTails = phrases.timeTails[period] || [];
      const lead = useTime ? customerLead(period, useCustomer ? name : '') : (useCustomer && name ? name : '');

      if (useSeasonal && seasonal.length) {
        seasonal.forEach((line) => {
          candidates.push(lead ? `${lead} — ${line}` : capitalizeSentence(line));
        });
      }

      if (useTime && timeTails.length) {
        timeTails.forEach((line) => {
          candidates.push(lead ? `${lead} — ${line}` : capitalizeSentence(line));
        });
      }

      if (!candidates.length && lead) candidates.push(`${lead}.`);
      return candidates;
    }

    function buildRotationPool({ period, stage, name, useCustomer, useTime, useSeasonal, useFortune, fallback }) {
      const pool = [];
      const seasonal = phrases.seasonal[stage] || [];

      if (useTime) pool.push(...(phrases.time[period] || []));
      if (useSeasonal) pool.push(...seasonal.map(capitalizeSentence));

      if (useTime && useSeasonal) {
        pool.push(...buildPriorityCandidates({ period, stage, name, useCustomer, useTime, useSeasonal }));
      } else if (useTime && useCustomer && name) {
        const lead = customerLead(period, name);
        pool.push(`${lead} — what are we finding today?`);
        pool.push(`${lead} — let’s wander the shelves.`);
      }

      pool.push(...phrases.dreamy, ...phrases.quippy, ...phrases.discovery, ...phrases.homeMoments);
      if (useFortune) pool.push(...phrases.fortune);
      if (fallback) pool.push(fallback);

      return unique(pool);
    }

    function formatMoney(cents) {
      if (cents === null || cents === undefined || cents === '') return '';
      const number = Number(cents);
      if (Number.isNaN(number)) return '';

      const currency = window.Shopify?.currency?.active || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency
        }).format(number / 100);
      } catch (error) {
        return `$${(number / 100).toFixed(2)}`;
      }
    }

    function escapeHtml(value) {
      return String(value ?? '')
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }

    function productImage(product) {
      if (!product) return '';
      if (typeof product.featured_image === 'string') return product.featured_image;
      return product?.featured_image?.url || product?.image || '';
    }

    function renderSection(title, items, renderer) {
      if (!items.length) return '';
      return `
        <section class="new-predictive-section">
          <h3 class="new-predictive-heading">${escapeHtml(title)}</h3>
          <ul class="new-predictive-list">${items.map(renderer).join('')}</ul>
        </section>
      `;
    }

    function renderProduct(product) {
      const image = productImage(product);
      const price = formatMoney(product.price);
      return `
        <li role="option">
          <a class="new-predictive-link" href="${escapeHtml(product.url)}">
            ${image ? `<img class="new-predictive-image" src="${escapeHtml(image)}" alt="" loading="lazy" width="104" height="104">` : ''}
            <span class="new-predictive-meta">
              <span class="new-predictive-title">${escapeHtml(product.title)}</span>
              ${price ? `<span class="new-predictive-subtitle new-predictive-price">${escapeHtml(price)}</span>` : ''}
            </span>
          </a>
        </li>
      `;
    }

    function renderCollection(collection) {
      return `
        <li role="option">
          <a class="new-predictive-link" href="${escapeHtml(collection.url)}">
            <span class="new-predictive-meta">
              <span class="new-predictive-title">${escapeHtml(collection.title)}</span>
              <span class="new-predictive-subtitle">Collection</span>
            </span>
          </a>
        </li>
      `;
    }

    function renderQuery(query) {
      const text = query.text || query.title || query.styled_text || '';
      const raw = String(text).replace(/<[^>]*>/g, '');
      const href = query.url || `${window.Shopify?.routes?.root || '/'}search?q=${encodeURIComponent(raw)}&type=product`;
      return `
        <li role="option">
          <a class="new-predictive-link" href="${escapeHtml(href)}">
            <span class="new-predictive-meta">
              <span class="new-predictive-title">${escapeHtml(raw)}</span>
              <span class="new-predictive-subtitle">Suggested search</span>
            </span>
          </a>
        </li>
      `;
    }

    function initSearch(root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const input = root.querySelector('.search-page-input');
      const panel = root.querySelector('[data-new-predictive]');
      const reset = root.querySelector('[data-new-search-reset]');
      if (!input) return;

      const now = new Date();
      const period = timePeriod(now);
      const stage = seasonStage(now);
      const isHomepage = toBool(root.dataset.isHomepage);
      const intelligenceEnabled = toBool(root.dataset.enableIntelligence);
      const useCustomer = toBool(root.dataset.enableCustomer);
      const useTime = toBool(root.dataset.enableTime);
      const useSeasonal = toBool(root.dataset.enableSeasonal);
      const useFortune = toBool(root.dataset.enableFortune);
      const rotatePrompts = toBool(root.dataset.rotatePrompts);
      const rotationSeconds = Math.max(3, Math.min(30, Number(root.dataset.rotationDelay || 10)));
      const rotationMs = rotationSeconds * 1000;
      const name = safeCustomerName(root.dataset.customerName);
      const fallback = clean(root.dataset.fallbackPlaceholder) || 'Search the shelves…';
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      const mobileLimit = mobile ? Number(root.dataset.mobilePromptCharLimit || 0) : 0;

      let currentPrompt = fallback;
      let rotationTimer = null;
      let promptQueue = [];

      const setPrompt = (nextPrompt, animate = true) => {
        const prompt = clean(nextPrompt) || fallback;
        if (prompt === currentPrompt && input.placeholder === prompt && input.getAttribute('placeholder') === prompt) return;

        if (!animate) {
          currentPrompt = prompt;
          input.placeholder = prompt;
          input.setAttribute('placeholder', prompt);
          return;
        }

        input.classList.add('new-search-prompt-changing');
        window.setTimeout(() => {
          currentPrompt = prompt;
          input.placeholder = prompt;
          input.setAttribute('placeholder', prompt);
          input.classList.remove('new-search-prompt-changing');
        }, 180);
      };

      if (intelligenceEnabled) {
        const priorityCandidates = buildPriorityCandidates({
          period,
          stage,
          name,
          useCustomer,
          useTime,
          useSeasonal
        });

        const rotationPool = buildRotationPool({
          period,
          stage,
          name,
          useCustomer,
          useTime,
          useSeasonal,
          useFortune,
          fallback
        });

        const seenPriority = sessionHas(SESSION_KEY);
        const shouldPrioritize = isHomepage && toBool(root.dataset.firstHomePriority) && !seenPriority;

        if (shouldPrioritize && priorityCandidates.length) {
          currentPrompt = pickWithinLimit(priorityCandidates, mobileLimit) || fallback;
          input.placeholder = currentPrompt;
          input.setAttribute('placeholder', currentPrompt);
          sessionSet(SESSION_KEY);
        } else {
          currentPrompt = pickWithinLimit(rotationPool, mobileLimit) || fallback;
          input.placeholder = currentPrompt;
          input.setAttribute('placeholder', currentPrompt);
        }

        const nextRotatingPrompt = () => {
          if (!promptQueue.length) {
            promptQueue = buildPromptQueue(rotationPool, mobileLimit, currentPrompt);
          }
          return promptQueue.shift() || fallback;
        };

        if (rotatePrompts && rotationPool.length > 1) {
          rotationTimer = window.setInterval(() => {
            if (input.value.trim()) return;
            const next = nextRotatingPrompt();
            setPrompt(next);
          }, rotationMs);
        }
      } else {
        input.placeholder = fallback;
        input.setAttribute('placeholder', fallback);
      }

      if (!panel || !toBool(root.dataset.enablePredictive)) return;

      let controller = null;
      let searchTimer = null;

      const closePanel = () => {
        panel.hidden = true;
        panel.innerHTML = '';
        input.setAttribute('aria-expanded', 'false');
      };

      const openPanel = () => {
        panel.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      };

      const runSearch = async () => {
        const term = input.value.trim();
        if (term.length < 2) {
          closePanel();
          return;
        }

        if (controller) controller.abort();
        controller = new AbortController();

        const rootUrl = window.Shopify?.routes?.root || '/';
        const params = new URLSearchParams();
        params.set('q', term);
        params.set('resources[type]', 'product,collection,query');
        params.set('resources[limit]', '10');
        params.set('resources[options][unavailable_products]', 'last');
        params.set('resources[options][fields]', 'title,body,product_type,tag,vendor,variants.title');

        try {
          const response = await fetch(`${rootUrl}search/suggest.json?${params.toString()}`, {
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          });

          if (!response.ok) throw new Error(`Predictive search failed: ${response.status}`);

          const data = await response.json();
          const results = data?.resources?.results || {};
          const productLimit = Number(root.dataset.productLimit || 6);
          const collectionLimit = Number(root.dataset.collectionLimit || 3);
          const queryLimit = Number(root.dataset.queryLimit || 4);

          const products = (results.products || []).slice(0, productLimit);
          const collections = (results.collections || []).slice(0, collectionLimit);
          const queries = (results.queries || []).slice(0, queryLimit);

          if (!products.length && !collections.length && !queries.length) {
            panel.innerHTML = '<p class="new-predictive-empty">Nothing yet — try another word or two.</p>';
            openPanel();
            return;
          }

          const viewAllUrl = `${rootUrl}search?type=product&q=${encodeURIComponent(term)}`;
          panel.innerHTML = [
            renderSection('Suggested searches', queries, renderQuery),
            renderSection('Collections', collections, renderCollection),
            renderSection('Products', products, renderProduct),
            `<a class="new-predictive-view-all" href="${escapeHtml(viewAllUrl)}">See all results for “${escapeHtml(term)}”</a>`
          ].join('');
          openPanel();
        } catch (error) {
          if (error.name !== 'AbortError') closePanel();
        }
      };

      input.addEventListener('input', () => {
        window.clearTimeout(searchTimer);
        searchTimer = window.setTimeout(runSearch, 180);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closePanel();
      });

      input.addEventListener('focus', () => {
        if (input.value.trim().length >= 2 && panel.innerHTML.trim()) openPanel();
      });

      reset?.addEventListener('click', (event) => {
        event.preventDefault();
        input.value = '';
        input.focus();
        closePanel();
      });

      document.addEventListener('click', (event) => {
        if (!root.contains(event.target)) closePanel();
      });

      root.addEventListener('shopify:block:unload', () => {
        if (rotationTimer) window.clearInterval(rotationTimer);
        if (controller) controller.abort();
      }, { once: true });
    }

    function initAll() {
      document.querySelectorAll(SELECTOR).forEach(initSearch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
